
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UploadFile, ChangeLight } from "../request";
@Component({})
export default class Name extends Vue {
  @Prop()
  private ifShow: any;
  @Watch("ifShow", { immediate: true })
  private async ifShowChange() {
    this.visible = this.ifShow;
    if (this.ifShow) {
      // 关闭紫光
      console.log("打开弹框后：紫外光-OFF");
      const res = await window.electronMyAPI.changeLight("紫外光-OFF");
      if (res) {
        this.$store.commit("updateIfShowZiwai", false);
        // 打开均匀光
        console.log("打开弹框后：白光-ON-100");
        window.electronMyAPI.changeLight("白光-ON-100");
      }
      this.getCameraDevices();
    } else {
    }
  }
  private visible: any = false;
  private stream: any = "";
  private photoData: any = "";
  private imgData: any = [];
  private imgs: any = [];
  private devices: any = [];
  private cDevice: any = {};
  private filming: any = false;
  private times: any = 0; // 当前查找次数
  private maxTimes: any = 4; // 最大重复次数
  private cancel() {
    this.$emit("cancel");
    if (this.stream) {
      this.stream.getTracks().forEach((track: any) => track.stop());
    }
    this.resetCamera();
    this.imgs = [];
    this.imgData = [];
    this.devices = [];
    this.cDevice = {};
    // 关闭均匀光
    window.electronMyAPI.changeLight("白光-OFF");
    this.filming = false;
  }
  private preview(url: any) {
    window.open(url);
  }
  private resetPhoto() {
    this.imgs = [];
    this.imgData = [];
    this.resetCamera();
    this.startCamera();
  }
  private selectDevice(item: any) {
    this.cDevice = item;
    this.startCamera();
  }
  private base64ToBlob(base64Data: string, contentType = ""): Blob {
    contentType = contentType || base64Data.split(",")[0].split(":")[1];
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  private async startCamera() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        // video: true,
        video: {
          deviceId: { exact: this.cDevice.deviceId },
          width: { exact: 3840 },
          height: { exact: 2880 },
          // height: { exact: 3040 },
        },
      });
      (this.$refs.video as any).srcObject = this.stream;
      (this.$refs.video2 as any).srcObject = this.stream;
    } catch (err) {
      console.error("Error accessing the camera:", err);
      this.$message.warning("请再点击一次");
      // this.devices = [];
      this.cDevice = {};
      this.getCameraDevices();
    }
  }
  private startTakePhoto() {
    this.takePhoto().then(() => {
      const loading = this.$loading({
        lock: true,
        text: "图片上传中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      this.upload(this.imgData[0]).then(() => {
        loading.close();
        this.filming = false;
      });
    });
    return;
    if (this.filming) {
      return;
    }
    // 第一次拍摄
    this.filming = true;
    this.changeLight().then(() => {
      this.takePhoto().then(() => {
        // 第二次拍摄
        this.changeLight().then(() => {
          this.takePhoto().then(() => {
            // 第三次拍摄
            this.changeLight().then(() => {
              this.takePhoto().then(async () => {
                const res = await window.electronMyAPI.changeLight(
                  "平行光-OFF"
                );
                // 延时1秒调光
                if (res) {
                  // 保存图片
                  const loading = this.$loading({
                    lock: true,
                    text: "图片上传中……",
                    spinner: "el-icon-loading",
                    customClass: "loadClass",
                    background: "rgba(255, 255, 255, 0.7)",
                  });
                  this.upload(this.imgData[0]).then(() => {
                    this.upload(this.imgData[1]).then(() => {
                      this.upload(this.imgData[2]);
                      loading.close();
                      this.filming = false;
                    });
                  });
                }
              });
            });
          });
        });
      });
    });
  }
  private changeLight() {
    return new Promise(async (resolve, reject) => {
      if (this.imgData.length == 0) {
        const res = await window.electronMyAPI.changeLight("白光-ON-100");
        // 延时1秒调光
        if (res) {
          resolve(true);
        }
      } else if (this.imgData.length == 1) {
        const res = await window.electronMyAPI.changeLight("白光-OFF");
        if (res) {
          const res2 = await window.electronMyAPI.changeLight("绿光-ON");
          if (res2) {
            resolve(true);
          }
        }
      } else if (this.imgData.length == 2) {
        const res = await window.electronMyAPI.changeLight("绿光-OFF");
        if (res) {
          const res2 = await window.electronMyAPI.changeLight("平行光-ON");
          if (res2) {
            resolve(true);
          }
        }
      }
    });
  }
  private takePhoto() {
    return new Promise((resolve, reject) => {
      if (this.stream) {
        const video = this.$refs.video as HTMLVideoElement;
        // const canvas = this.$refs.canvas as HTMLCanvasElement;
        const canvas = document.createElement("canvas"); // 创建一个新的canvas元素，不添加到DOM中

        // 设置 Canvas 尺寸为视频帧旋转后的尺寸
        canvas.width = video.videoHeight; // 旋转后的宽度是原始高度
        canvas.height = video.videoWidth; // 旋转后的高度是原始宽度
        const context: any = canvas.getContext("2d");

        // 清除画布
        context.clearRect(0, 0, canvas.width, canvas.height);

        // 保存当前状态
        context.save();

        // 转换原点至画布中心
        context.translate(canvas.width / 2, canvas.height / 2);

        // 旋转画布90度（顺时针）
        context.rotate(Math.PI / 2);

        // 绘制视频帧
        context.drawImage(
          video,
          0,
          0, // 从视频左上角开始，绘制整个视频帧
          video.videoWidth,
          video.videoHeight, // 视频帧的原始宽度和高度
          -video.videoWidth / 2,
          -video.videoHeight / 2, // 从画布中心点的x轴负方向开始（旋转后的y轴）
          video.videoWidth,
          video.videoHeight // 使用视频帧的原始尺寸绘制到画布上
        );

        // 恢复状态
        context.restore();

        // 捕获旋转后的图像数据
        // this.photoData = canvas.toDataURL("image/png");
        // this.imgData.push(this.photoData);
        canvas.toBlob(
          (blob) => {
            if (blob) {
              // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
              const reader = new FileReader();
              reader.onload = (e: any) => {
                this.photoData = e.target.result;
                this.imgData.push(this.photoData);
                resolve(true);
              };
              reader.readAsDataURL(blob);
            } else {
              reject(new Error("Failed to generate image blob"));
            }
          },
          "image/jpeg",
          0.7
        ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
      }
    });
  }
  private resetCamera() {
    console.log("重新拍摄");
    // 重置photoData和Canvas
    this.stream = "";
    this.photoData = "";
    const canvas = this.$refs.canvas as HTMLCanvasElement;

    if (canvas) {
      const context: any = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
    }
  }
  private sure() {
    this.$emit("sure", this.imgs);
  }
  private upload(d: any) {
    return new Promise((resolve, reject) => {
      // 将 photoData 转换为 Blob 对象
      const blob = this.base64ToBlob(d);
      // 获取当前时间的时间戳（毫秒级）
      const timestamp = Date.now();
      const filename = `${timestamp}.jpg`;
      // FormData 对象
      const form = new FormData();
      // Blob 对象作为文件添加到表单中
      form.append("file", blob, filename); // 可以指定文件名

      UploadFile(this, form)
        .then((res: any) => {
          this.imgs.push(res.data);
          resolve(res.data);
        })
        .catch(() => {
          reject();
        });
    });
  }
  private async getCameraDevices() {
    this.times = 1;
    console.log("查找次数：" + this.times);
    const loading = this.$loading({
      lock: true,
      text: "查找设备中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        // alert("enumerateDevices 不可用");
        loading.close();
        // this.$message.warning("enumerateDevices 不可用");
        setTimeout(() => {
          this.getCameraDevices2();
        }, 1000);
        return;
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          console.log("设备列表");
          console.log(devices);
          this.devices = devices.filter(
            (device) => device.kind === "videoinput"
          );
          loading.close();
          if (this.devices.length == 0) {
            // this.$message.warning("没有符合条件的设备");
            setTimeout(() => {
              this.getCameraDevices2();
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("列出摄像头时发生错误:", error);
          loading.close();
          // this.$message.warning("没有符合条件的设备");
          setTimeout(() => {
            this.getCameraDevices2();
          }, 1000);
        });
    } catch (err) {
      console.error("Error accessing the camera:", err);
      loading.close();
      // this.$message.warning("没有符合条件的设备");
      setTimeout(() => {
        this.getCameraDevices2();
      }, 1000);
    }
  }
  private async getCameraDevices2() {
    this.times += 1;
    console.log("查找次数：" + this.times);
    const loading = this.$loading({
      lock: true,
      text: "查找设备中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        // alert("enumerateDevices 不可用");
        loading.close();
        // this.$message.warning("enumerateDevices 不可用");
        setTimeout(() => {
          if (this.times < 5) {
            this.getCameraDevices2();
          }
        }, 1000);
        return;
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          console.log("设备列表");
          console.log(devices);
          this.devices = devices.filter(
            (device) => device.kind === "videoinput"
          );
          loading.close();
          if (this.devices.length == 0) {
            // this.$message.warning("没有符合条件的设备");
            setTimeout(() => {
              if (this.times < this.maxTimes) {
                this.getCameraDevices2();
              }
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("列出摄像头时发生错误:", error);
          loading.close();
          // this.$message.warning("没有符合条件的设备");
          setTimeout(() => {
            if (this.times < this.maxTimes) {
              this.getCameraDevices2();
            }
          }, 1000);
        });
    } catch (err) {
      console.error("Error accessing the camera:", err);
      loading.close();
      // this.$message.warning("没有符合条件的设备");
      setTimeout(() => {
        if (this.times < this.maxTimes) {
          this.getCameraDevices2();
        }
      }, 1000);
    }
  }
  private mounted() {
    // this.getCameraDevices();
  }
}
